<template>
	<div>
		<v-container align="center" justify="center" class="pa-5">
			<v-row class="justify-center text-center"
				><v-col>
					<v-card :max-width="483" elevation="5" :max-height="327" mx-auto class="mx-auto">
						<v-img
							mx-auto
							class="mx-auto justify-center text-center"
							:max-width="483"
							:max-height="327"
							src="https://media.giphy.com/media/xTiTnEHBh7qapyuvwQ/giphy.gif"
						>
						</v-img>
					</v-card> </v-col
			></v-row>
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap"><h1>Congrats!</h1></v-list-item-title>
					<v-list-item-subtitle class="text-center text-wrap">Your practice is now active.</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-container>
	</div>
</template>

<script>
import { bus } from '@/main';
import router from '@/router';
import { Tracking } from '@/utils';

export default {
	components: {},
	data: () => ({
		step: 'completed-step',
	}),

	mounted() {
		Tracking.track('Practice_Profile_Complete', {});
		window.scrollTo(0, 0);
		bus.$on('intent:submit-forms:completed-step', () => {
			bus.$emit('update:spinning', true);
			router.push('/').catch(() => {});
		});
		bus.$emit('update:next-button-text', 'Find locums');
		bus.$emit('update:next-button-color', '#63C367');
		bus.$emit('push:notification@hide');
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms:completed-step');
	},

	methods: {},
};
</script>
